import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AlarmApiService } from './api/alarmApi.service';
import { BookingApiService } from './api/bookingApi.service';
import { BreakApiService } from './api/breakApi.service';
import { CommandsApiService } from './api/commandsApi.service';
import { CompanyApiService } from './api/companyApi.service';
import { ConvApiService } from './api/convApi.service';
import { DeviceOperationApiService } from './api/deviceOperationApi.service';
import { DevicesApiService } from './api/devicesApi.service';
import { DocumentApiService } from './api/documentApi.service';
import { EmptyZonesApiService } from './api/emptyZonesApi.service';
import { GbfsApiService } from './api/gbfsApi.service';
import { HubApiService } from './api/hubApi.service';
import { InstitutionApiService } from './api/institutionApi.service';
import { MapApiService } from './api/mapApi.service';
import { MdsApiService } from './api/mdsApi.service';
import { ModelApiService } from './api/modelApi.service';
import { NewsApiService } from './api/newsApi.service';
import { PaymentMethodApiService } from './api/paymentMethodApi.service';
import { ProfileApiService } from './api/profileApi.service';
import { PromotionApiService } from './api/promotionApi.service';
import { ProviderService } from './api/provider.service';
import { RateApiService } from './api/rateApi.service';
import { RentalApiService } from './api/rentalApi.service';
import { ReportApiService } from './api/reportApi.service';
import { ScheduledBookingApiService } from './api/scheduledBookingApi.service';
import { SubscriptionApiService } from './api/subscriptionApi.service';
import { TranslationApiService } from './api/translationApi.service';
import { VoucherApiService } from './api/voucherApi.service';
import { WalletApiService } from './api/walletApi.service';
import { WebhookApiService } from './api/webhookApi.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AlarmApiService,
    BookingApiService,
    BreakApiService,
    CommandsApiService,
    CompanyApiService,
    ConvApiService,
    DeviceOperationApiService,
    DevicesApiService,
    DocumentApiService,
    EmptyZonesApiService,
    GbfsApiService,
    HubApiService,
    InstitutionApiService,
    MapApiService,
    MdsApiService,
    ModelApiService,
    NewsApiService,
    PaymentMethodApiService,
    ProfileApiService,
    PromotionApiService,
    ProviderService,
    RateApiService,
    RentalApiService,
    ReportApiService,
    ScheduledBookingApiService,
    SubscriptionApiService,
    TranslationApiService,
    VoucherApiService,
    WalletApiService,
    WebhookApiService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
